import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        showFilter: '='
    },
    template: `
        <home-employees-filter
            sites="vm.sites"
            list="vm.list"
            default-filter="vm.defaultFilter"
            show-filter="vm.showFilter"
        />
        <div class="tablewrapper">
            <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
            <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length">
                <thead>
                <tr>
                    <th>{{ 'home.Employee name' | translate }}</th>
                    <th>{{ 'home.Employee position' | translate }}</th>
                    <th>{{ 'home.Employee mandatory courses' | translate }} <small>({{ 'home.without deadline' | translate }})</small></th>
                    <th>{{ 'home.Employment status' | translate }}</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="item in vm.list.items">
                    <td>{{ item.displayName }}</td>
                    <td>
                        <p ng-repeat="drl in item.drlsWithValue">{{ drl.departmentName }}, {{ drl.roleName }}, {{ drl.levelName }}</p>
                    </td>
                    <td>
                        <a ng-if="vm.PrivilegeService.canManagePlanning()" ng-click="vm.setDeadline(item)">
                            {{ item.userStatistic.requiredCourseCount }} <small>({{ item.userStatistic.requiredCourseCountWoDeadline }})</small>
                        </a>
                        <span ng-if="!vm.PrivilegeService.canManagePlanning()">
                            {{ item.userStatistic.requiredCourseCount }} <small>({{ item.userStatistic.requiredCourseCountWoDeadline }})</small>
                        </span>
                    </td>
                    <td>{{ vm.getStatusLabel(item) }}</td>
                </tr>
                </tbody>
            </table>
            <pagination list="vm.list"></pagination>
        </div>
    `
})

export default class {
    constructor ($translate, lodash, moment, DATATABLES, ListFactory, UserResource, MomentService, SiteService,
                 ModalService, PrivilegeService, ROLE_CODE_ENUM, USER_STATUS_ENUM, ROLE_PRIVILEGE_ENUM) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.ListFactory = ListFactory;
        this.UserResource = UserResource;
        this.MomentService = MomentService;
        this.SiteService = SiteService;
        this.ModalService = ModalService;
        this.PrivilegeService = PrivilegeService;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
    }

    $onInit () {
        this.sites = this.SiteService.getSitesByPrivileges(
            [this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_VIEW, this.ROLE_PRIVILEGE_ENUM.KEYS.PLANNING_MANAGE]
        );
        this.defaultFilter = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            workingSinceFrom: this.moment().subtract(30, 'days').format('YYYY-MM-DD'),
            woDeadlineCourses: true,
            statuses: [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED],
            siteIds: this.sites.map((site) => site.id)
        };

        this.list = this.ListFactory.createWithPagination(this.UserResource.getUser.bind(this.UserResource));
        this.list.sort = 'workingSince';
        this.list.fetch({ pageSize: 10, expand: 'drlsWithValue,userStatistic' }, this.defaultFilter);
    }

    setDeadline (user) {
        this.ModalService.open({
            size: 'xlarge',
            template: `
                <modals-user-courses-deadline class="wrapper"
                    ok="vm.$uibModalInstance.close()"
                    cancel="vm.$uibModalInstance.dismiss()"
                    user="vm.user"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.user = user;
            }
        }).then(() => {
            this.list.fetch({ pageSize: 10, expand: 'drlsWithValue,userStatistic' }, this.filter);
        });
    }

    getStatusLabel (user) {
        if (user.status === this.USER_STATUS_ENUM.KEYS.ACTIVE) {
            return this.$translate.instant(
                'user.Started {workingSince}',
                { workingSince: this.MomentService.formatDate(user.workingSince) }
            );
        }
        return this.$translate.instant(
            'user.Starting {workingSince}',
            { workingSince: this.MomentService.formatDate(user.workingSince) }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/home/employees/index.js